// extracted by mini-css-extract-plugin
export default {"viewByPlaceholder":"styles_viewByPlaceholder__ob0Nh","viewByLabel":"styles_viewByLabel__vG3pH","viewByLabel__active":"styles_viewByLabel__active__2gEfu"};